import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import palettes from '@prose-ui/foundations/colors';
import { styled } from 'legacyStyles';

import Typography from 'Components/Typography';

import { productsCategories } from 'constants/products';

import { getSubscriptionDiscount } from 'dux/checkoutCart/selectors';
import {
  shouldShowPostPurchaseCrossSellOffer,
  shouldShowTrialOffer,
} from 'dux/featureFlags/selectors';
import {
  getHasHairTopicalsSubscriptionInAnyState,
  getHasSkincareSubscriptionInAnyState,
} from 'dux/user/selectors';
import { Variant } from 'dux/featureFlags/postPurchaseCrossSellOfer';

import useCheckoutCategory from '../hooks/useCheckoutCategory';

const FreeShippingCountdownWrapper = styled.div`
  width: 100%;
  background-color: ${({ shouldSeeExperiment }) =>
    shouldSeeExperiment ? palettes.tertiary[300] : palettes.subscription[300]};
  text-align: center;
  padding: 10px 8px 8px 8px;
  border-radius: 4px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-bottom: 16px;
  }
`;

const FreeShippingSection = ({ className }) => {
  const subscriptionDiscount = useSelector(getSubscriptionDiscount);
  const checkoutCategory = useCheckoutCategory();
  const showPostPurchaseCrossSellOffer = useSelector(shouldShowPostPurchaseCrossSellOffer);
  const showTrialOffer = useSelector(shouldShowTrialOffer);
  const hasHaircareSubscriptionInAnyState = useSelector(getHasHairTopicalsSubscriptionInAnyState);
  const hasSkincareSubscriptionInAnyState = useSelector(getHasSkincareSubscriptionInAnyState);

  const show50DiscountMessage =
    (showTrialOffer &&
      ((checkoutCategory === productsCategories.HAIRCARE && !hasHaircareSubscriptionInAnyState) ||
        (checkoutCategory === productsCategories.SKINCARE &&
          !hasSkincareSubscriptionInAnyState))) ||
    (showPostPurchaseCrossSellOffer === Variant.FIRST_ORDER_50_OFFER &&
      checkoutCategory === productsCategories.SKINCARE);

  return (
    <div className={className}>
      <FreeShippingCountdownWrapper shouldSeeExperiment={show50DiscountMessage}>
        <Typography variant="p2">
          <Typography data-testid="free-shipping-section-ticket" markupName="span" variant="p2">
            {show50DiscountMessage ? (
              <>
                <b>50% off</b> + <b>free shipping</b> applied!
              </>
            ) : (
              <>
                <b>{subscriptionDiscount}% off</b> + <b>free shipping</b> applied!
              </>
            )}
          </Typography>
        </Typography>
      </FreeShippingCountdownWrapper>
    </div>
  );
};

FreeShippingSection.propTypes = {
  className: PropTypes.string,
};

FreeShippingSection.defaultProps = {
  className: '',
};

export default FreeShippingSection;
